import { useSetAtom } from "jotai";
import {
  setAddPrintTemplateAtom,
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import {
  getAndSetPrintTemplatesAtom,
  usePrintTemplatesState,
} from "../../../atoms/printTemplatesAtom";

import { deletePrintTemplate } from "../api";

export const PrintTemplatesFooter = (): JSX.Element => {
  const { printTemplatesState } = usePrintTemplatesState();

  const closeModal = useSetAtom(setModalCloseAtom);
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const setAddPrintTemplate = useSetAtom(setAddPrintTemplateAtom);
  const getAndSetPrintTemplates = useSetAtom(getAndSetPrintTemplatesAtom);

  const onDeleteConfirm = async () => {
    await deletePrintTemplate({
      template_id: printTemplatesState.activePrintTemplate!.template_id,
    });

    await getAndSetPrintTemplates();

    closeModal();
  };

  const handleDelete = () => {
    if (printTemplatesState.activePrintTemplate) {
      setConfirmationModal({
        title: "Вы действительно хотите удалить этот шаблон для печати?",
        onConfirm: onDeleteConfirm,
      });
    }
  };

  const handleAdd = () => {
    setAddPrintTemplate(false);
  };

  return (
    <div className="flex flex-row ">
      <Button icon="plus" onClick={handleAdd}>
        Добавить шаблон
      </Button>
      <HorizontalSpace size={11} />
      <Button icon="delete" onClick={handleDelete} />
    </div>
  );
};
